"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityUrlField = exports.entityPasswordField = exports.entityEmailField = exports.entityTextAreaField = exports.entityFloatNumberField = exports.entityNumberField = exports.entityNameField = exports.entityTextField = void 0;
var react_1 = __importDefault(require("react"));
var sprintf_js_1 = require("sprintf-js");
var input_text_1 = require("../components/forms/input-text");
var entity_field_1 = require("./entity-field");
var onNameBlur = function (context) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      if (context.onNameBlur) {
        context.onNameBlur(context.value);
      }
      return [2 /*return*/];
    });
  });
};
var entityTextField = function (args) {
  var inputType = args.inputType;
  var ret = __assign(__assign({}, (0, entity_field_1.entityFieldArgs)(args)), {
    render: function (props) {
      return react_1.default.createElement(input_text_1.InputText, __assign({}, props, {
        type: inputType
      }));
    }
  });
  return ret;
};
exports.entityTextField = entityTextField;
var entityNameField = function (args) {
  var context = args.context;
  var definition = context.definition,
    t = context.t;
  var required = args.required === undefined ? true : args.required;
  var focus = args.focus === undefined ? true : args.focus;
  var description = args.description && t(args.description) || (0, sprintf_js_1.sprintf)(t('Please provide a name for this %s. '), definition.label);
  return (0, exports.entityTextField)(__assign(__assign({}, args), {
    onBlur: onNameBlur,
    required: required,
    focus: focus,
    description: description,
    name: args.name || 'name'
  }));
};
exports.entityNameField = entityNameField;
var entityNumberField = function (args) {
  return (0, exports.entityTextField)(__assign(__assign({
    maxWidth: '300px'
  }, args), {
    inputType: 'number'
  }));
};
exports.entityNumberField = entityNumberField;
var entityFloatNumberField = function (args) {
  return (0, exports.entityTextField)(__assign(__assign({
    maxWidth: '300px'
  }, args), {
    inputType: 'float'
  }));
};
exports.entityFloatNumberField = entityFloatNumberField;
var entityTextAreaField = function (args) {
  return (0, exports.entityTextField)(__assign(__assign({}, args), {
    inputType: 'textarea'
  }));
};
exports.entityTextAreaField = entityTextAreaField;
var entityEmailField = function (args) {
  return (0, exports.entityTextField)(__assign(__assign({
    name: 'email',
    maxWidth: '800px',
    validate: input_text_1.validateEmail
  }, args), {
    inputType: 'email'
  }));
};
exports.entityEmailField = entityEmailField;
var entityPasswordField = function (args) {
  return (0, exports.entityTextField)(__assign(__assign({}, args), {
    inputType: 'password'
  }));
};
exports.entityPasswordField = entityPasswordField;
var entityUrlField = function (args) {
  var context = args.context;
  var definition = context.definition,
    t = context.t;
  var description = args.description && t(args.description) || (0, sprintf_js_1.sprintf)(t('Please provide the URL (web address) for this %s. '), definition.label);
  var placeholder = args.placeholder || 'https://example.com';
  return (0, exports.entityTextField)(__assign(__assign({}, args), {
    description: description,
    placeholder: placeholder,
    name: args.name || 'url',
    validate: input_text_1.validateUrl
  }));
};
exports.entityUrlField = entityUrlField;